import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import {
  Box,
  Breadcrumb,
  Breadcrumbs as BreadcrumbsWrapper,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { DEVICE_GALLERY_PAGE, LEGACY_SHOP_ROUTE } from 'shared/constants';
import { useSegment } from 'shared/hooks';
import { getPath } from 'shared/utils';

// offsets the default padding on pattern lib Breadcrumbs
const Container = styled(Box)`
  margin-left: -4px;
`;

interface Category {
  id: string;
  name: string;
}

interface BreadCrumbsProps {
  category: Category;
  deviceGroupName: string;
  subCategoryId: string;
}

const BreadCrumbs = ({
  category,
  deviceGroupName,
  subCategoryId,
}: BreadCrumbsProps) => {
  const { channel } = useSegment();
  const categoryPath = subCategoryId
    ? `/${subCategoryId}`
    : `${DEVICE_GALLERY_PAGE}`;

  const categoryFullPath = getPath(categoryPath, channel);

  const breadcrumbs = [
    { url: '/', label: 'Home' },
    { url: LEGACY_SHOP_ROUTE, label: 'Shop' },
    {
      url: categoryFullPath,
      label: category.name,
      internal: true,
    },
    { url: '#', label: deviceGroupName, internal: true },
  ];

  return (
    <LinkRegion regionId="breadcrumbs">
      <Container mb={['s2', 's2', 's4']}>
        <BreadcrumbsWrapper>
          {breadcrumbs.map(({ url, label, internal }, index) => {
            const breadcrumb = (
              <Breadcrumb
                key={url}
                href={url}
                onClick={() => trackCustomLink(label)}
                isLastBreadcrumb={breadcrumbs.length - 1 === index}
              >
                {label}
              </Breadcrumb>
            );

            return internal ? (
              <Link key={url} href={url} passHref legacyBehavior>
                {breadcrumb}
              </Link>
            ) : (
              breadcrumb
            );
          })}
        </BreadcrumbsWrapper>
      </Container>
    </LinkRegion>
  );
};

export default BreadCrumbs;
